import axios from 'axios';

export function getAxiosStatus(error: unknown): number | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const status = error.response?.status;
  return typeof status === 'number' ? status : undefined;
}

export function isCancelledError(error: unknown): boolean {
  const anyError = error as any;
  const name = anyError?.name;
  const code = anyError?.code;
  return (
    name === 'CanceledError' ||
    name === 'AbortError' ||
    code === 'ERR_CANCELED' ||
    code === 'ECONNABORTED'
  );
}

